import { SelectWorkflowComponent } from './common/selectcomponent'
import {
  Provider,
  WorkflowComponentParamType,
  WorkflowComponentParameterMode,
  WorkflowComponentCodeParams
} from '../types'
import dedent from 'ts-dedent'

class ColsToArray extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.colstoarray',
        group: 'Data Preparation',
        title: 'Columns to array',
        description: `
      This component adds a new column with an array containing the values in a set of selected columns.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'cols',
          type: WorkflowComponentParamType.Column,
          title: 'Columns',
          parent: 'source',
          mode: WorkflowComponentParameterMode.Multiple
        },
        {
          name: 'arraycol',
          type: WorkflowComponentParamType.String,
          title: 'Array column name',
          default: 'arraycol',
          allowExpressions: false
        }
      ]
    )
  }

  getInnerSql({ params, connection, envVars }: WorkflowComponentCodeParams) {
    const preparedParams = this._prepareParameters(params)
    let array = ''
    switch (connection.type) {
      case Provider.BigQuery:
        array = `[${(preparedParams.cols as Array<string>).join(', ')}]`
        break
      case Provider.Snowflake:
        array = dedent`ARRAY_CONSTRUCT(${(preparedParams.cols as Array<string>).join(', ')})`
        break
      case Provider.Postgres:
        array = dedent`ARRAY[${(preparedParams.cols as Array<string>).join(', ')}]`
        break
      case Provider.Redshift:
      case Provider.DatabricksRest:
        array = dedent`ARRAY(${(preparedParams.cols as Array<string>).join(', ')})`
        break
    }

    if (connection.type === Provider.DatabricksRest) {
      return dedent`SELECT /*+ REPARTITION(40) */
                      *,
                      ${array} AS ${params.arraycol}
                    FROM
                      ${connection.quoteName(params.source as string)}`
    } else {
      return dedent`SELECT
                      *,
                      ${array} AS ${params.arraycol}
                    FROM
                      ${connection.quoteName(params.source as string)}`
    }
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Postgres, Provider.Redshift, Provider.Snowflake, Provider.DatabricksRest]
  }
}

export { ColsToArray }
